import React, { FC } from 'react';
import ConfirmDialog from '@components/Dialogs/ConfirmDialog';
import { Box, Typography } from '@mui/material';
import { ValidationChangePlan } from '@utils/validationStatusEligibility';

type Props = {
  open: boolean;
  toChange: ValidationChangePlan['toChange'];
  unchanged: ValidationChangePlan['unchanged'];
  onBack: () => void;
  onConfirm: () => void;
};

export const SetValidationStatusModal: FC<Props> = ({
  open,
  toChange,
  unchanged,
  onBack,
  onConfirm,
}) => (
  <ConfirmDialog
    open={open}
    onClose={onBack}
    onBack={onBack}
    onConfirm={onConfirm}
    disabled={toChange.length === 0}
    title="Set validation status"
    text="The selected status cannot be applied to all selected entities."
    confirmName="Set status"
    backName="Cancel"
  >
    {toChange.length > 0 && (
      <>
        <Typography variant="h5" color="grey.900">
          Status will be set:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 5, color: 'grey.900' }}>
          {toChange.map((node) => (
            <li key={node.id}>{node.name}</li>
          ))}
        </Box>
      </>
    )}

    {unchanged.length > 0 && (
      <>
        <Typography variant="h5" color="grey.900">
          Status will not be set:
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 5, color: 'grey.900' }}>
          {unchanged.map(({ node }) => (
            <li key={node.id}>{node.name}</li>
          ))}
        </Box>
      </>
    )}
  </ConfirmDialog>
);
